import { useState, useEffect } from "react";
import { InputBox, SubmitButton, UploadBox } from "../../components/Input";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import CompanyHeader from "./CompanyHeader";

const CompanyOfferForm = () => {
  const [formData, setFormData] = useState({
    company_name: "",
    offercode: "",
    offerimage: "",
  });
  const [file, setFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  // Fetch data from an API or load it dynamically here
  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/company/company-info`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFormData(response.data.data || {});
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("offercode", formData.offercode);
      if (file) {
        formDataToSend.append("offerimage", file);
      }
      const response = await axios.put(
        `${API_URL}settings/company/update?id=${formData.id}`, // query param instead of path param
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        fetchCompany();
      } else {
        showToast.error(response.data.message);
      }
    } catch (error) {
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <CompanyHeader />
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form
            onSubmit={handleSubmit}
            name="frm1"
            className="stdform"
            encType="multipart/form-data"
          >
            <div className="panel-heading border-0">
              <span className="panel-title">Edit Company Details</span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Offer Code Text */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Offer Code Text"
                    fieldname="offercode"
                    value={formData.offercode}
                    onChange={handleChange}
                    placeholder="Enter Offer Code Text"
                  />
                </div>

                {/* Upload Offer Image */}
                <div className="col-md-4 mb-2">
                  <UploadBox
                    label="Upload Offer Image"
                    fieldname="filename"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/Company"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Conditional rendering of the image if offer image exists */}
        {formData.offerimage && (
          <div className="image-preview">
            <img
              src={formData.offerimage}
              alt="Offer Image"
              style={{ maxWidth: "300px" }}
            />
          </div>
        )}

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default CompanyOfferForm;
